import { render, staticRenderFns } from "./SalesByBranchesList.vue?vue&type=template&id=13ef60b3"
import script from "./SalesByBranchesList.vue?vue&type=script&lang=js"
export * from "./SalesByBranchesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports